import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoeRoutingModule } from './coe-routing.module';
import { ApplicationDashboardComponent } from './components/application-dashboard/application-dashboard.component';
import { HostInstitutionComponent } from './components/host-institution/host-institution.component';
import { PocDetailsComponent } from './components/poc-details/poc-details.component';
import { TrackRecordApplicantComponent } from './components/track-record-applicant/track-record-applicant.component';
import { FeasibilitySustainabilityComponent } from './components/feasibility-sustainability/feasibility-sustainability.component';
import { CommitmentsFromApplicantComponent } from './components/commitments-from-applicant/commitments-from-applicant.component';
import { WorkplanComponent } from './components/workplan/workplan.component';
import { BudgetComponent } from './components/budget/budget.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { IonicModule } from '@ionic/angular';
import { NumberToWordsPipe } from './number-to-words.pipe';
import { WorkplanListComponent } from './components/workplan-list/workplan-list.component';
import { BreakupBudgetComponent } from './components/breakup-budget/breakup-budget.component';
import { FinancingComponent } from './components/financing/financing.component';
import { RevenueGenerationComponent } from './components/revenue-generation/revenue-generation.component';
import { DeclarationComponent } from './components/declaration/declaration.component';
import { CoeRejectComponent } from './components/coe-reject/coe-reject.component';
import { CoeApprovalComponent } from './components/coe-approval/coe-approval.component';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
  declarations: [
    ApplicationDashboardComponent,
    NumberToWordsPipe,
    HostInstitutionComponent,
    PocDetailsComponent,
    TrackRecordApplicantComponent,
    FeasibilitySustainabilityComponent,
    CommitmentsFromApplicantComponent,
    WorkplanComponent,
    BudgetComponent,
    NumberToWordsPipe,
    WorkplanListComponent,
    BreakupBudgetComponent,
    FinancingComponent,
    RevenueGenerationComponent,
    DeclarationComponent,
    CoeRejectComponent,
    CoeApprovalComponent,
  ],
  imports: [
    CommonModule,
    CoeRoutingModule,
    FormsModule,
    MatTabsModule,
    ReactiveFormsModule,
    MaterialModule,
    IonicModule.forRoot(),
  ],
})
export class CoeModule {}
